module.exports = __webpack_public_path__ + "img/Tessellate42.92f042fc.jpg";